import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import CatalogViewPage from '@features/catalog/CatalogViewPage.tsx';
import { useCreateCatalogViewStore } from '@features/catalog/useCatalogView.ts';

const catalogSearchSchema = z.object({
  selectedSupplierIds: z.array(z.number()).optional(),
  supplierFilterLevel: z.number().optional(),
});

export const Route = createFileRoute('/c/$orgId/$portalId/catalog/')({
  validateSearch: search => catalogSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    console.log('Category: beforeLoad', ctx.search);
    useCreateCatalogViewStore.getState().initializeCatalog(null, ctx.search.selectedSupplierIds, ctx.search.supplierFilterLevel);
  },
});

function RouteComponent() {
  const { selectedSupplierIds, supplierFilterLevel } = Route.useSearch();

  return <CatalogViewPage categoryEcid={undefined} selectedSupplierIds={selectedSupplierIds} supplierFilterLevel={supplierFilterLevel} />;
}
